import { Link } from 'gatsby';
import React, { useContext } from 'react';
import AppContext from '../context';
import { TagWrapper } from '../elements';

const Icon = (value, dark) => {
  switch (value) {
    case 'Math':
      return dark
        ? { bgColor: '#856404', color: '#fff3cd' }
        : { color: '#856404', bgColor: '#fff3cd' };
    case 'Cryptography':
      return dark
        ? { bgColor: '#155724', color: '#d4edda' }
        : { color: '#155724', bgColor: '#d4edda' };
    case 'Cyber Security':
      return dark
        ? { bgColor: '#E95604', color: '#F0C48C' }
        : { color: '#E95604', bgColor: '#F0C48C' };
    default:
      return dark
        ? { bgColor: '#004085', color: '#cce5ff' }
        : { color: '#004085', bgColor: '#cce5ff' };
  }
};

export const Tags = ({ tags }) => {
  const { dark } = useContext(AppContext);

  return (
    <TagWrapper>
      {tags.map((tag, i) => {
        const { color, bgColor } = Icon(tag, dark);
        return (
          <div
            className='tag-element'
            style={{
              backgroundColor: bgColor,
              marginLeft: i === 0 ? 0 : '0.5rem',
              marginRight: i === tags.length - 1 ? 0 : '0.5rem',
            }}
          >
            <Link
              className='tag-link'
              to={`/tags/${tag.toLowerCase().split(' ').join('-')}`}
              key={i}
              style={{ color }}
            >
              {tag}
            </Link>
          </div>
        );
      })}
    </TagWrapper>
  );
};
